import React from "react"
import { type Token } from "./types"

export const TokenContext = React.createContext<Token | null>(null)

export const useToken = (): string | null => React.useContext(TokenContext)
